import { useEffect, useState } from 'react';
import { subscribeTeachers } from '@services/registry';

/** Full tenant teacher list (realtime), for selects and cross-references. */
export function useTenantTeachersList({ tenantId }) {
    const [rows, setRows] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (!tenantId) {
            setRows([]);
            setLoading(false);
            return;
        }
        setLoading(true);
        let unsub = () => {};
        try {
            unsub = subscribeTeachers({
                tenantId,
                onNext: (next) => {
                    setRows(next);
                    setLoading(false);
                    setError(null);
                },
                onError: (err) => {
                    console.error(err);
                    setError(err);
                    setLoading(false);
                },
            });
        } catch (e) {
            setError(e);
            setLoading(false);
        }
        return () => unsub?.();
    }, [tenantId]);

    return { rows, loading, error };
}
